import { type INotificationDTO } from 'dto/NotificationDTO'
import { type INotificationOrderParams } from 'dto/NotificationDTO/order'

export const redirectOrderNotification = (notification: INotificationDTO) => {
  const { orderId } = notification.params as INotificationOrderParams

  return `/pedidos/${orderId}`
}
